  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
      <b-row>
        <b-col cols="12" md="6">
          <validation-provider
            #default="{ errors }"
            name="título"
            rules="required"
          >
            <b-form-group label="Título" label-for="titulo">
              <b-form-input
                id="titulo"
                v-model="eventTask.titulo"
                data-cy="input-titulo"
                :state="errors.length > 0 ? false : null"
                placeholder="Digite o título da tarefa"
                :disabled="!canEditOrInsert"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" md="6">
          <validation-provider
            #default="{ errors }"
            name="evento"
            rules="required"
          >
            <b-form-group label="Evento" label-for="evento">
              <v-select
                id="evento"
                v-model="eventTask.evento"
                data-cy="select-evento"
                :options="eventos"
                label="nome"
                :reduce="(evento) => evento"
                placeholder="Selecione o evento"
                :disabled="!canEditOrInsert"
              >
                <template #no-options>
                  <div class="text-muted">Nenhum evento encontrado</div>
                </template>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12">
          <b-form-group label="Descrição" label-for="descricao">
            <b-form-textarea
              id="descricao"
              v-model="eventTask.descricao"
              data-cy="input-descricao"
              placeholder="Digite a descrição da tarefa"
              rows="3"
              :disabled="!canEditOrInsert"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <validation-provider
            #default="{ errors }"
            name="responsável"
            rules="required"
          >
            <b-form-group label="Responsável" label-for="responsavel">
              <v-select
                id="responsavel"
                v-model="eventTask.responsavel"
                data-cy="select-responsavel"
                :options="responsaveis"
                label="nome"
                :reduce="(resp) => resp"
                placeholder="Selecione o responsável"
                :disabled="!canEditOrInsert"
              >
                <template #no-options>
                  <div class="text-muted">Nenhum responsável encontrado</div>
                </template>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" md="6">
          <validation-provider
            #default="{ errors }"
            name="data prevista"
            rules="required"
          >
            <b-form-group label="Data Prevista" label-for="dataPrevista">
              <flat-pickr
                id="dataPrevista"
                v-model="eventTask.dataPrevista"
                data-cy="input-data-prevista"
                class="form-control"
                :config="dateConfig"
                placeholder="Selecione a data"
                :disabled="!canEditOrInsert"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12">
          <b-form-checkbox
            v-model="eventTask.concluida"
            data-cy="switch-concluida"
            name="concluida"
            switch
            :disabled="!canEditOrInsert"
            @change="handleConclusaoChange"
          >
            {{ eventTask.concluida ? "Concluída" : "Pendente" }}
          </b-form-checkbox>
        </b-col>

        <b-col cols="12" v-if="eventTask.concluida">
          <b-form-group label="Data de Conclusão" label-for="dataConclusao">
            <flat-pickr
              id="dataConclusao"
              v-model="eventTask.dataConclusao"
              class="form-control"
              :config="dateConfig"
              placeholder="Selecione a data de conclusão"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-checkbox
            v-model="eventTask.ativo"
            data-cy="switch-ativo"
            name="ativo"
            switch
            :disabled="!canEditOrInsert"
          >
            {{ eventTask.ativo ? "Sim" : "Não" }}
          </b-form-checkbox>
        </b-col>

        <ButtonsFormVue
          :permission-insert="verificarPermissao('ROLE_EVENTOS_INSERIR')"
          :permission-edit="verificarPermissao('ROLE_EVENTOS_ATUALIZAR')"
          :disable-form="false"
          @save="save"
          @cancel="cancel"
        />
      </b-row>
    </b-form>
  </validation-observer>
</b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BCard,
  BForm,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import { verificarPermissao } from '@/auth/utils'

export default {
  name: 'EventTaskForm',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BCard,
    BForm,
    vSelect,
    flatPickr,
    ButtonsFormVue,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      verificarPermissao,
      titleForm: 'Cadastro de Tarefas de Evento',
      required,
      dateConfig: {
        dateFormat: 'Y-m-d',
        locale: 'pt',
      },
      eventos: [],
      responsaveis: [],
    }
  },
  computed: {
    ...mapState('eventTaskSettingsModule', {
      eventTask: state => state.eventTask,
    }),
    canEditOrInsert() {
      return (
        (!this.eventTask.id
          && this.verificarPermissao('ROLE_EVENTOS_INSERIR'))
        || (this.eventTask.id
          && this.verificarPermissao('ROLE_EVENTOS_ATUALIZAR'))
      )
    },
  },
  created() {
    this.loadDependencies()
  },
  methods: {
    async loadDependencies() {
      try {
        const queryParams = {
          page: 1, size: 1000, sort: 'nome', order: 'asc',
        }

        // Load Events
        this.$store.dispatch('eventSettingsModule/loadTable', queryParams)
          .then(result => {
            this.eventos = result.data.content
          })

        // Load Responsibles (Profissionais)
        this.$store.dispatch('combosModule/loadComboProfissionalByName', '')
          .then(result => {
            this.responsaveis = result.data.content
          })
      } catch (error) {
        console.error('Error loading dependencies:', error)
      }
    },
    handleConclusaoChange(checked) {
      if (checked) {
        this.eventTask.dataConclusao = new Date().toISOString().split('T')[0]
      } else {
        this.eventTask.dataConclusao = null
      }
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          const payload = {
            ...this.eventTask,
            evento: { id: this.eventTask.evento?.id },
            responsavel: { id: this.eventTask.responsavel?.id },
          }

          const action = this.eventTask.id ? 'edit' : 'insertNew'
          this.$store
            .dispatch(`eventTaskSettingsModule/${action}`, payload)
            .then(response => {
              if (response.response) {
                this.MensagemError(
                  this.eventTask.id ? 'Falha ao Editar' : 'Falha ao Inserir',
                  response.response.data.error,
                )
                return
              }
              this.showMessageSuccess(
                this.eventTask.id ? 'Editar' : 'Salvo',
                this.eventTask.id
                  ? 'Editado com sucesso!'
                  : 'Incluído com sucesso!',
              )
              this.cancel()
            })
        }
      })
    },
    cancel() {
      this.$emit('cancelar')
      this.$store.dispatch('eventTaskSettingsModule/reset')
    },
  },
}
</script>
